export default "__VITE_PUBLIC_ASSET__5f558a96__"